import React, { useState, useEffect } from "react";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import { modules } from "../../../constants/Modules";
import { useGetNotOnboardedUsers } from "../../../queryHooks";
import { useStore } from "../../../zustand/store";
import CS from "../../../services/commonService";
import qs from "qs";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";

const PendingUsers = () => {
	const lastPageData = useStore((state) => state.lastPageData);
	const setLastPageData = useStore((state) => state.setLastPageData);
	//	State values
	const [tableData, setTableData] = useState();
	const [pageNow, setPageNow] = useState(
		lastPageData?.[modules.PENDING_USERS]?.page || 1
	);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[modules.PENDING_USERS]?.items_per_page || 10
	);
	const [usersPayload, setUsersPayload] = useState(
		lastPageData?.[modules.PENDING_USERS] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			sort: { name: "DESC" },
			filter: {
				is_guest_user: false,
			},
		}
	);

	/******************************************************************************************
	@Purpose    :   To get the users list
	*******************************************************************************************/

	const {
		data: dataGetAllUsers,
		isLoading,
		refetch,
	} = useGetNotOnboardedUsers(qs.stringify(usersPayload));

	useEffect(() => {
		if (dataGetAllUsers && dataGetAllUsers.status === "success") {
			let respData = dataGetAllUsers.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetAllUsers]);

	const columns = [
		{
			label: "User Id",
			type: "string",
			// sort: true,
			path: "id",
			// alias: "mobile",
		},
		{
			label: "Name",
			type: "string",
			path: "name",
			alias: "first_name",
			sort: true,
			content: (item) => (
				<div className="d-flex align-items-center">
					<div className="flex-auto">
						{CS.renderImageUrl(item.profile_image_url)}
					</div>
					<div className="d-flex flex-column flex-wrap">
						<span className="pl-2">
							{item.first_name} {item.last_name}
						</span>
					</div>
				</div>
			),
		},
		{
			label: "Phone Number",
			type: "string",
			// sort: true,
			path: "mobile",
			// alias: "mobile",
		},
		{
			label: "Referral Code",
			type: "string",
			// sort: true,
			path: "referral_code",
			content: (item) => (
				<span className="">
					{item.referral_code ? item.referral_code : "N.A."}
				</span>
			),
		},
		{
			label: "Joined Date",
			type: "date",
			sort: true,
			filterDate: true,
			path: "created_at",
			alias: "created_at",
			content: (item) => getCurrentTimezoneDate(item.created_at),
		},
	];

	return (
		<React.Fragment>
			<div className="grid-content">
				<div className="user-listing-filterOptions mb-2 d-block">
					<div className="row mb-2">
						<div className="col-sm-8 mb-2 position-static">
							<div className="left-buttons d-flex">
								<SearchBox
									columnKey={modules.PENDING_USERS}
									searchValue={
										lastPageData?.[modules.PENDING_USERS]?.search?.username
									}
									search={(value) => {
										setPageNow(1);
										setUsersPayload({
											...usersPayload,
											search: {
												username: !value && value === "" ? undefined : value,
												email: !value && value === "" ? undefined : value,
												mobile: !value && value === "" ? undefined : value,
												first_name: !value && value === "" ? undefined : value,
												last_name: !value && value === "" ? undefined : value,
												referral_code:
													!value && value === "" ? undefined : value,
											},
											page: 1,
										});
									}}
								/>
							</div>
						</div>
					</div>
				</div>
				<Table
					columnKey={modules.PENDING_USERS}
					columns={columns}
					tableData={tableData}
					payload={usersPayload}
					sortCol={(obj) => {
						setPageNow(1);
						setUsersPayload({
							...usersPayload,
							sort: {
								[obj.alias]:
									!obj.sort && obj.sort === "" ? undefined : obj.sort,
							},
							page: 1,
						});
					}}
					setCurrentPage={(page) => {
						setPageNow(page);
						setUsersPayload({
							...usersPayload,
							page,
						});
					}}
					setCurrentLimit={(items_per_page) => {
						setPageNow(1);
						setItemsPerPage(items_per_page);
						setUsersPayload({
							...usersPayload,
							items_per_page,
							page: 1,
						});
					}}
					loading={isLoading}
					filterValue={async (obj) => {
						if (obj.filter === null) {
							const resp = await CS.filterData(usersPayload.filter, obj);
							setPageNow(1);
							setUsersPayload({
								...usersPayload,
								filter: resp,
								page: 1,
							});
						} else {
							setPageNow(1);
							setUsersPayload({
								...usersPayload,
								filter: {
									...usersPayload.filter,
									[obj.alias]: obj.filter,
								},
								page: 1,
							});
						}
					}}
					filterDate={(dates) => {
						setPageNow(1);
						setUsersPayload({
							...usersPayload,
							filter_date: dates && {
								[dates.alias]: String(dates.filter),
							},
							page: 1,
						});
					}}
				/>
			</div>
		</React.Fragment>
	);
};

export default PendingUsers;
